import newRestAPI from "./RestAPI";

const SeshAPI = newRestAPI("/api/v1/seshes");

export default SeshAPI;
